import { render, staticRenderFns } from "./AuditForm.vue?vue&type=template&id=522fd73b&scoped=true"
import script from "./AuditForm.vue?vue&type=script&lang=js"
export * from "./AuditForm.vue?vue&type=script&lang=js"
import style0 from "./AuditForm.vue?vue&type=style&index=0&id=522fd73b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fd73b",
  null
  
)

export default component.exports